import type { AlertProps as AntdAlertProps } from "antd";
import { Alert as AntdAlert } from "antd";
import React from "react";
import * as styles from "./Alert.css";

export interface AlertProps extends Omit<AntdAlertProps, "type"> {
  ariaLabel?: string;
  type?: AntdAlertProps["type"] | "utility";
}

const Alert: React.FC<AlertProps> = ({
  ariaLabel,
  type,
  className,
  ...props
}) => {
  const variantClass =
    type === "utility" ? styles.alertVariants.utility : undefined;
  const composedClassName = [variantClass, className].filter(Boolean).join(" ");

  return (
    <AntdAlert
      {...props}
      type={type as AntdAlertProps["type"]}
      aria-label={ariaLabel || props.message?.toString() || "Alert Message"}
      role="alert"
      className={composedClassName || undefined}
    />
  );
};

export default Alert;
